import { WebinarDurationSettingsPage } from '@online-webinar/management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/manage/webinar-duration'].update({
        staticData: { title: { page: 'WebinarDurationSettings.PageHeading' } },
        component: authGuard(WebinarDurationSettingsPage, { hasRights: true })
    });
};
